var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-snackbar',{attrs:{"timeout":3000,"color":_vm.$store.state.snackbar_color},model:{value:(_vm.$store.state.snackbar_status),callback:function ($$v) {_vm.$set(_vm.$store.state, "snackbar_status", $$v)},expression:"$store.state.snackbar_status"}},[_vm._v(" "+_vm._s(_vm.$store.state.snackbar_text)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }